var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-card-outter-wrapper",style:(_vm.compact ? 'padding: 22px 15px 0px;' : 'padding: 34px 15px 20px 15px;')},[_c('span',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }